import { Alert, Modal, Spinner, Table } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { getAuthToken } from "../../utils/AuthUtils";
import { API } from 'aws-amplify';
import { BENCHMARK_CODE_MAP } from "../../Constants";

const SurveyDataPointsPreviewModal = ({ show, onClose, selectedSurveyRows, selectedSurveyTemplateId, surveyYear }) => {

    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [dataPoints, setDataPoints] = useState({});

    const fetchSurveyDataPointsPreviewValues = async () => {
        setLoading(true);
        setShowError(false);
        const companyIds = extractCompanyIds(selectedSurveyRows);
        const queryStringParameters = {
            templateId: selectedSurveyTemplateId,
            companyIds,
            surveyYear
        }
        const authToken = await getAuthToken();
        API.get('AnnualCompensations', "/survey-preview/output", {
            headers: {
                'Token': authToken
            },
            queryStringParameters
        }).then((response) => {
            setLoading(false);
            setDataPoints(response);
        }).catch((error) => {
            setLoading(false);
            if (error !== undefined && error.response !== undefined &&
                error.response.data !== undefined && error.response.data.message !== undefined) {
                setErrorMessage(error.response.data.message);
                setShowError(true);
            }
        });
    }

    const dataPointsTable = (<div>
        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th style={{ width: '30%' }} className="fw-semibold small text-uppercase py-2">Benchmark</th>
                    <th style={{ width: '14%' }} className="fw-semibold small text-uppercase py-2">Companies</th>
                    <th style={{ width: '14%' }} className="fw-semibold small text-uppercase py-2">Salary</th>
                    <th style={{ width: '14%' }} className="fw-semibold small text-uppercase py-2">Bonus</th>
                    <th style={{ width: '14%' }} className="fw-semibold small text-uppercase py-2">LTI</th>
                    <th style={{ width: '14%' }} className="fw-semibold small text-uppercase py-2">TDC</th>
                </tr>
            </thead>
            <tbody>
                {Object.keys(BENCHMARK_CODE_MAP).map((key) => (
                    <tr key={key}>
                        <td>{BENCHMARK_CODE_MAP[key]}</td>
                        <td>{dataPoints[key]?.companies ?? 0}</td>
                        <td>{dataPoints[key]?.salary ?? 0}</td>
                        <td>{dataPoints[key]?.bonus ?? 0}</td>
                        <td>{dataPoints[key]?.lti ?? 0}</td>
                        <td>{dataPoints[key]?.tdc ?? 0}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>)


    const extractCompanyIds = (selectedSurveyRows) => {
        const companyIds = [];
        for (const row of selectedSurveyRows) {
            const elements = row.split("#");
            companyIds.push(elements[2]);
        }
        return companyIds.join(",");
    }

    const handleClose = () => {
        setLoading(false);
        setShowError(false);
        setErrorMessage("");
        setDataPoints({});
        onClose();
    }

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (show) {
                fetchSurveyDataPointsPreviewValues();
            }
        }
        return () => { isMounted = false };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return (
        <Modal show={show} onHide={handleClose} size="xl" contentClassName="modal-container" scrollable dialogClassName="dashboard-modal">
            <Modal.Header closeButton>
                <h5 className='mb-0'>Sample Sizes Preview</h5>
            </Modal.Header>
            <Modal.Body>
                {(loading && dataPoints) ? <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    aria-hidden="true"
                /> :
                    <div>{dataPointsTable}
                    </div>}
                {showError ?? <Alert variant="danger" dismissible>{errorMessage}</Alert>}
            </Modal.Body>
        </Modal>
    )
}

export default SurveyDataPointsPreviewModal;
